import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "FundManagement" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "content-container" }, " This page is currently under development. ", -1)
const _hoisted_3 = [
  _hoisted_2
]


export default /*#__PURE__*/_defineComponent({
  __name: 'FundManagement',
  setup(__props) {

document.title = 'Fund Management - UV';

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}
}

})